<div class="asc-btn-option">
  <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
    <ng-container *ngIf="isImportBtn">
      <button class="flex items-center justify-center" nz-button nzTooltipTitle="Import"
        nzTooltipPlacement="bottom" nz-tooltip (click)="importEvent($event)">
        <i nz-icon nzType="import" nzTheme="outline"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="isPrintBtn">
      <button 
        class="flex items-center justify-center" 
        nz-button 
        nzTooltipTitle="In" 
        nzTooltipPlacement="bottom"
        (click)="printEvent($event)" 
        nz-tooltip
        >
        <i 
          nz-icon 
          nzType="printer" 
          nzTheme="outline"
          >
        </i>
      </button>
    </ng-container>
    <ng-container *ngIf="isExcelBtn">  
      <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
      nzTooltipPlacement="bottom" nz-tooltip (click)="excelEvent($event)">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="isAddBtn">
      <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
      nzTooltipPlacement="bottom" nz-tooltip (click)="AddEvent($event)">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="isDeleteBtn">
      <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
      nzTooltipPlacement="bottom" nz-tooltip (click)="deleteEvent($event)">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
    <ng-container *ngIf="isImportBtn">
      <button class="flex items-center justify-center" nz-button (click)="importEvent($event)">
        Import
      </button>
    </ng-container>
    <ng-container *ngIf="isPrintBtn">
      <button 
      class="flex items-center justify-center" 
      nz-button
      >In
      </button>
    </ng-container>
    <ng-container *ngIf="isExcelBtn">
      <button nz-button class="flex items-center justify-center" (click)="excelEvent($event)">
        Xuất excel
      </button>
    </ng-container>
    <ng-container *ngIf="isAddBtn">
      <button class="flex items-center justify-center" nz-button (click)="AddEvent($event)">Thêm
      </button>
    </ng-container>
    <ng-container *ngIf="isDeleteBtn">
      <button class="flex items-center justify-center" nz-button (click)="deleteEvent($event)">Xóa
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
    <ng-container *ngIf="isImportBtn">
      <button class="flex items-center justify-center" nz-button (click)="importEvent($event)">
        <i nz-icon nzType="import" nzTheme="outline"></i>Import
      </button>
    </ng-container>
    <ng-container *ngIf="isPrintBtn">
      <button 
      class="flex items-center justify-center" 
      nz-button 
      >
      <i 
        nz-icon 
        nzType="printer" 
        nzTheme="outline"
        >
      </i>In
    </button>
    </ng-container>
    <ng-container *ngIf="isExcelBtn">
      <button nz-button class="flex items-center justify-center" (click)="excelEvent($event)">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        Xuất excel
      </button>
    </ng-container>
    <ng-container *ngIf="isAddBtn">
      <button class="flex items-center justify-center" nz-button (click)="AddEvent($event)">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        Thêm
      </button>
    </ng-container>
    <ng-container *ngIf="isDeleteBtn">
      <button class="flex items-center justify-center text-red-600" nz-button (click)="deleteEvent($event)">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
        Xóa
      </button>
    </ng-container>
  </ng-container>
</div>
